const WAITER_SESSION_KEY = "activeWaiterSession";

export function getActiveWaiter() {
  try {
    return JSON.parse(sessionStorage.getItem(WAITER_SESSION_KEY) || "null");
  } catch (error) {
    return null;
  }
}

export function setActiveWaiter(waiter) {
  sessionStorage.setItem(WAITER_SESSION_KEY, JSON.stringify(waiter));
}

export function clearActiveWaiter() {
  sessionStorage.removeItem(WAITER_SESSION_KEY);
}

export function activeWaiterCode() {
  const waiter = getActiveWaiter();
  return waiter && waiter.code ? waiter.code : "";
}
